import moment from "moment/moment";
import { getIntentDisplay as utilsGetIntentDisplay } from "./components/merchants/detail";
import { currentUserHasMoney, MONEY_MASK } from "./lib/permissions";

export function moneyValue(value) {
  // financials.view gate: mask every monetary figure for users without it.
  if (!currentUserHasMoney()) {
    return MONEY_MASK;
  }
  if (!value) {
    return 0;
  }

  const roundedValue = Math.round(value * 1000) / 1000;
  return roundedValue.toLocaleString();
}

export function getCleanMonth(date) {
  return moment(date).format('MMMM YYYY')
}

export function getIntentDisplay(intent) {
  switch (intent) {
    case "TRANSFER":
      return "Salary Transfer"
    case "WITHDRAW":
      return "Withdrawal"
    default:
      return utilsGetIntentDisplay(intent)
  }
}

export function downloadFile(data, filename) {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export function getStartEndDate(date = null, startDay = 21, endDay = 20) {
  const today = date ? new Date(date) : new Date(); // clone the provided Date or use now
  const startDate = new Date(today);
  const endDate = new Date(today);

  if (today.getDate() >= startDay) {
    // Current period started this month
    startDate.setDate(startDay);
    endDate.setMonth(today.getMonth() + 1);
    endDate.setDate(safeEndMonthDayorNearest(endDate, endDay));
  } else {
    // Current period started last month
    startDate.setMonth(today.getMonth() - 1);
    startDate.setDate(startDay);
    endDate.setDate(safeEndMonthDayorNearest(endDate, endDay));
  }

  return [startDate, endDate];
}
/**
 * 
 * @param {*} date 
 * @param {*} endDay 
 * returns the last day of the month if endDay is greater than the last day of the month
 * otherwise returns the endDay
 */
export function safeEndMonthDayorNearest(date, endDay = 31) {
  const lastDay = moment(date).endOf('month').date();
  return endDay > lastDay ? lastDay : endDay;
}
/**
 * @param {null|Date} date
 * @param {number | 1} startDay
 * @param {number | 31} endDay
 */
export function getStartMonthDayAndEndMonthDay(date = null, startDay = 1, endDay = 31) {
  const today = date ? new Date(date) : new Date();
  const startDate = new Date(today);
  const endDate = new Date(today);
  startDate.setMonth(today.getMonth());
  startDate.setDate(startDay);
  endDate.setMonth(today.getMonth());
  endDate.setDate(safeEndMonthDayorNearest(endDate, endDay));
  return [startDate, endDate];
}